<template>
  <div class="configurator-page-tool-info" 
       id="configurator-page-tool-info" 
       :class="{ 'configurator-page-tool-info__marathon': pointStore.selectedPoint.isMarathon, 
       'configurator-page-tool-info__open': !!pointStore.selectedPoint }">
    <div class="configurator-page-tool-info__wrapper">
      <div class="configurator-page-tool-info__content">
        <div class="configurator-page-tool-info__details">
          <h2>
            <span class="icon icon--marathon" v-if="pointStore.selectedPoint.isMarathon"></span>
            <span>{{ pointStore.selectedPoint.name }}</span>
          </h2>

          <div class="configurator-page-tool-info__presentation">
            <picture>
              <source :srcset="pointStore.selectedPoint.mobileImage" media="(max-width: 991px)"/>
              <img
                  :src="pointStore.selectedPoint.image"
                  :alt="pointStore.selectedPoint.imageAlt"
                  :title="pointStore.selectedPoint.imageTitle"
              />
            </picture>

            <div>
              <div v-html="pointStore.selectedPoint.mainBody"></div>
              <p>{{ translatedArtNr }}&nbsp;{{ pointStore.selectedPoint.articleNr }}</p>
            </div>
          </div>
        </div>

        <div class="configurator-page-tool-info__properties">
          <h3>{{ pointStore.selectedPoint.properties }}</h3>

          <div class="configurator-page-tool-info__icons">
            <div>
              <span class="icon" :class="[activeConfiguratorDepthIcon]"></span>
              <p>{{ pointStore.selectedPoint.range }}</p>
            </div>

            <div>
              <span class="icon" :class="[activeConfiguratorSizeIcon]"></span>
              <p>{{ pointStore.selectedPoint.width }}</p>
            </div>

            <div v-for="category in pointStore.selectedPoint.categories" v-bind:key="category.id">
              <span class="icon" :class="category.iconClass"></span>
              <p>{{ category.name }}</p>
            </div>
          </div>
        </div>

        <div class="configurator-page-tool-info__fittings" v-if="pointStore.selectedPoint.shins && pointStore.selectedPoint.shins.length > 0">
          <h3>{{ pointStore.selectedPoint.name }} {{ pointStore.selectedPoint.shinText }}</h3>

          <div class="configurator-page-tool-info__fittings-shin" v-for="shin in pointStore.selectedPoint.shins" v-bind:key="shin.id">
            <img :src="shin.image" :alt="shin.imageAlt" :title="shin.imageTitle"/>
            <div>
              <h4>{{ shin.name }}</h4>
              <p>{{ shin.imageText }}</p>
            </div>
          </div>
        </div>

      </div>
      <div class="configurator-page-tool-info__soil">
        <picture>
          <source :srcset="pointStore.selectedPoint.crossSectionMobileImage" media="(max-width: 991px)"/>
          <img
              class="configurator-page-tool-info__soil-cutthrough"
              :src="pointStore.selectedPoint.crossSectionImage"
              :alt="pointStore.selectedPoint.crossSectionImageAlt"
              :title="pointStore.selectedPoint.crossSectionImageTitle"
          />
        </picture>
      </div>
    </div>

    <aside class="configurator-page-tool-info__related-machines">
      <h3>{{ pointStore.selectedPoint.name }} {{ pointStore.selectedPoint.productText }}</h3>

      <div class="configurator-page-tool-info__machines">
        <div class="configurator-page-tool-info__machines-machine" v-for="product in pointStore.selectedPoint.products" :key="product.id">
          <a :href="product.link" class="link link--white">
            <img :src="product.image" :alt="product.name"/>
            <h4>{{ product.name }}</h4>
          </a>
        </div>
      </div>
    </aside>

    <div class="configurator-page-tool-info__close" @click="togglePoint(pointStore.selectedPoint)"></div>
  </div>
</template>

<script setup>
import {usePointStore} from '../store/store';
import {getActiveConfiguratorDepthIconClass, getActiveConfiguratorSizeIconClass} from '../helpers/configuratorHelper';
import {ref} from "vue";

const pointStore = usePointStore();

const activeConfiguratorDepthIcon = getActiveConfiguratorDepthIconClass();
const activeConfiguratorSizeIcon = getActiveConfiguratorSizeIconClass();
const translatedArtNr = ref(document.getElementById("articleNumberTranslation").value); // From Razor view script tag

const emit = defineEmits([
  'togglePoint'
]);

function togglePoint(point) {
  emit('togglePoint', point);
}

window.onclick = function (event) {
  var outside = document.getElementById('js-content');

  if (event.target == outside) {
    togglePoint(pointStore.selectedPoint);
  }
}
</script>